import React, { useState } from 'react';
import './assets/css/faqs.css';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "Who is the banker?",
      answer: "The banker is the person who organizes and manages the savings circle. They are responsible for collecting contributions, managing the group, and ensuring fair distribution of funds."
    },
    {
      question: "What is a draw?",
      answer: "A draw is the process of selecting which member will receive the collected funds in a particular round of the savings circle."
    },
    {
      question: "What is the pot total?",
      answer: "The pot total is the total amount of money collected from all members in a specific round of the savings circle."
    },
    {
      question: "What is the payment due date?",
      answer: "The payment due date is the specific date by which each member must make their contribution for the current round."
    },
    {
      question: "What is the payout date?",
      answer: "The payout date is when the selected member receives their payout from the collected funds."
    },
    {
      question: "Why is the end date blank?",
      answer: "The end date may be blank if the savings circle is ongoing or if the specific end date hasn't been determined yet."
    },
    {
      question: "What is an opt-in hand?",
      answer: "An opt-in hand is when a member chooses to participate in a specific round of the savings circle."
    },
    {
      question: "How and when do I choose my opt-in hand?",
      answer: "You can choose your opt-in hand through the platform interface during the designated selection period for each round."
    },
    {
      question: "Who chooses when I get my draw?",
      answer: "The draw selection is typically done through a fair random process or predetermined rotation system managed by the platform."
    },
    {
      question: "Can I swap my draw date?",
      answer: "Draw date swapping depends on the specific rules of your savings circle group and platform policies."
    },
    {
      question: "How will I know when I will receive my draw?",
      answer: "You will be notified through the platform when you are selected for a draw, including the payout date and amount."
    },
    {
      question: "What are the banker's fees?",
      answer: "Banker's fees are the charges for managing the savings circle, which vary depending on the platform and group size."
    },
    {
      question: "What is the loss recovery method?",
      answer: "The loss recovery method refers to the process used to handle situations where a member cannot make their payment or defaults."
    },
    {
      question: "How do I create a group?",
      answer: "You can create a group by using the group creation feature in the platform, setting up the rules, inviting members, and configuring the savings circle parameters."
    },
    {
      question: "What is a hand?",
      answer: "A \"hand\" refers to the specific contributions or payments made by each member. These contributions are determined and set by the banker or organizer when the savings circle is established."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
      </div>
      <div className="faq-list">
        {faqData.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${openIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <span className="faq-question-text">{faq.question}</span>
              <span className="faq-icon">
                {openIndex === index ? '−' : '+'}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;
